import { createFileRoute, notFound } from '@tanstack/react-router';

import LandlordTermsPage from '@/pages/landlord-terms/LandlordTermsPage';
import { getHomeHeaderButton } from '@/sanity/landing-page';
import { getLandlordTerms } from '@/sanity/landlord-terms';
import { getLegalLinks } from '@/sanity/legal-document';
import { landlordTermsPath } from '@/utils/landlord-terms';
import { buildPageMeta } from '@/utils/seo';

const landlordTermsTitle = 'Landlord terms — Budgy';
const landlordTermsDescription =
  'Terms that apply when you ask Budgy to contact letting agents and negotiate on your behalf.';

export const Route = createFileRoute('/landlord-terms')({
  loader: async () => {
    const [landlordTerms, headerButton, legalLinks] = await Promise.all([
      getLandlordTerms(),
      getHomeHeaderButton(),
      getLegalLinks(),
    ]);
    if (!landlordTerms) {
      throw notFound();
    }

    return { headerButton, landlordTerms, legalLinks };
  },
  component: LandlordTermsPage,
  head: () => {
    const pageMeta = buildPageMeta({
      title: landlordTermsTitle,
      description: landlordTermsDescription,
      path: landlordTermsPath,
    });

    // Shown to landlords at the point of consent, not promoted to search.
    return {
      ...pageMeta,
      meta: [...pageMeta.meta, { name: 'robots', content: 'noindex, follow' }],
    };
  },
});
